module.exports = __webpack_public_path__ + "img/ramn_2kl.e067a674.jpg";